import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from "react-helmet"

import { 
		Segment, 
		Form,
		Button,
		Container,
		Checkbox
	} from 'semantic-ui-react'

import user_model from 'models/user_model'
import NotificationsRequest from 'xAppLib/UIelems/NotificationsRequest'
import ProfileSelect from 'xAppLib/Users/ProfileSelect'
import PaymentForm from '../UIelems/PaymentForm'
import UserReferral from 'views/UIelems/UserReferral'
import Feedback from '../UIelems/Feedback'
import UserAvatar from './UserAvatar'
import { useUser } from 'xAppLib/Hooks'
import { useUserPrefs } from "xAppLib/Hooks";
import MFA from '../UIelems/MFA'


// const SHOW_REFERRAL_CODE = true
const DEBUG = false

function UserPreferences() {
	const [prefs, setPrefs] = useUserPrefs();

	const preferences = [
		user_model.check_access('GP') && (
			<Checkbox key="doc_cons_ppr" toggle checked={!!prefs.doc_cons_ppr} onChange={(e,{checked})=>{setPrefs('doc_cons_ppr',checked)}}
					  label='Send Paper Scripts in Consultation (off for eScripts, on for Paper)'
			/>
		),
		user_model.check_access('doc') && (
			<Checkbox key="instconst_wr_toast" toggle checked={!!prefs.instconst_wr_toast} onChange={(e,{checked})=>{setPrefs('instconst_wr_toast',checked)}}
					  label='Show Instant Consultation waiting room floating panel'
			/>
		),
	].filter(Boolean);

	if (preferences.length === 0) {
		return null;
	}

	const title = (() => {
		if (user_model.check_access('doc') || user_model.check_access('GP')) return 'Doctor Preferences';
		return 'User Preferences';
	})();

	return (
		<Segment className="flex flex-col">
			<h3>{title}</h3>

			{preferences}
		</Segment>
	)
}

const UserProfile = () => {
	const user = useUser()
	const [prefs,setPrefs] = useUserPrefs()
	user_model.limit_access('user');
	
	DEBUG && console.log('user profile :: user - ', user, user.user_det?.photoURL, app.dvc);

	return <Container >
				<Helmet>
					<title>Profile</title>
				</Helmet>

				<div style={{display:'flex'}}>
					<div>
						<UserAvatar size={50} />
					</div>
					<div style={{flex:1, marginLeft:'10px'}}>
						<h2 style={{marginBottom:0}}>{user.name} </h2>
						
						<p>{user.email}</p>
						
						{user.role != '' && user.role != 'Patient' &&
							<p style={{marginTop:0,marginBottom:0}}><strong>{user.role}</strong></p>
						}
						{app.user.org?.name && 
							<p style={{marginTop:0,marginBottom:0}}><strong>{app.user.org.name} ({app.user.org.address})</strong></p>
						}
							
					</div>
					
				</div>
				<footer className="my-5 flex gap-2">
					<Button basic content='Logout' onClick={ ()=>user_model.logout() }  />
					
					{user.usePassword && <Button basic as={Link} to={'/profile-password'} content='Change Password' />}
					<Button style={{marginLeft:'auto'}} basic content='Full Logout' onClick={ async ()=>user_model.full_logout() }  />
				</footer>


				<Segment basic id='user_signed_area' size='big' style={{padding: "0rem"} } >
					<aside>

						<Segment>
							<h3>My Profile</h3>
							<Form size="large">
								<ProfileSelect />
							</Form>
						</Segment>

						{/* <UserPreferences /> */}

						{/*<MFA showFactors/>*/}
		
						{/*<>
							<NotificationsRequest/>
							<Segment>
						
								<h3>My Payment Methods</h3>

								<Form size='large' className='meds'>
									<PaymentForm
										mode="view" 
										showSave={true} 
										// onSave={_=>this.setState({refresh:new Date().getTime()})}
									/>
								</Form>
							</Segment>
						</>*/}

						{/*SHOW_REFERRAL_CODE && (
							<UserReferral/>
						)*/}
					
						{/*<Segment>
        					<h3>Account Deletion</h3>
							<>{prefs.account_del_req && <p>Your account deletion request has been submitted on <strong>{prefs.account_del_req}</strong>.</p> 
								|| <p>If you would like to contact us to delete your account, please complete the following form to place a request with our support team.</p>}
							<Feedback trigger={<Button size={'small'} content={'Request Deletion'} disabled={prefs.account_del_req && true || false} color='grey'/>} request='account_del_req' /></>
    					</Segment>*/}
						

					</aside>

				</Segment>


</Container>;
}
 
export default UserProfile;
